export const VACATION_HOME = {
  nickname: 'PRODUCTS.VACATION_HOME.nickname',
  properties: [
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO' },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
    { name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'INSURANCE_INFO' },
    { name: 'objectZipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO' },
    { name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO' },
    { name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO' },
    { name: 'houseSumInsuredType', key: 'SUM_INSURED_TYPE', group: 'INSURANCE_INFO' },
    { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO' },
    { name: 'houseSurgeProtectionInFuseCabinet', key: 'HOUSE_SURGE_PROTECTION_IN_FUSE_CABINET', group: 'OBJECT_INFO' },
    { name: 'houseRotAndAnimalDamage', key: 'HOUSE_ROT_AND_ANIMAL_DAMAGE', group: 'INSURANCE_INFO' },
    { name: 'houseSMPipeInPipe', key: 'HOUSE_SM_PIPE_IN_PIPE', group: 'OBJECT_INFO' },
    { name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED', group: 'OBJECT_INFO' },
    { name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED', group: 'OBJECT_INFO' },
    { name: 'houseSMAutomaticCircuitBreaker', key: 'HOUSE_SM_AUTOMATIC_CIRCUIT_BREAKER', group: 'OBJECT_INFO' },
    { name: 'houseSMFlatRoof', key: 'HOUSE_SM_FLAT_ROOF', group: 'OBJECT_INFO' },
    { name: 'houseStandardCategory', key: 'HOUSE_STANDARD_CATEGORY', group: 'OBJECT_INFO' },
    { name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO' },
    { name: 'houseBuildingHasWater', key: 'HOUSE_BUILDING_HAS_WATER', group: 'OBJECT_INFO' },
    { name: 'houseBuildingHasPower', key: 'HOUSE_BUILDING_HAS_POWER', group: 'OBJECT_INFO' },
    { name: 'houseSM300FromRoad', key: 'HOUSE_SM_FROM_ROAD', group: 'OBJECT_INFO' },
    { name: 'houseSMhasLowBasement', key: 'HOUSE_SM_HAS_LOW_BASEMENT', group: 'OBJECT_INFO' },
    { name: 'houseSMElectricalControl', key: 'HOUSE_SM_ELECTRICAL_CONTROL', group: 'OBJECT_INFO' },
    { name: 'houseSMBehindLockedRoadBarrier', key: 'HOUSE_SM_BEHIND_LOCKED_ROAD_BARRIER', group: 'OBJECT_INFO' },
  ],
  icon:'vacation-home'
};
